import React from 'react';
import { connect } from 'react-redux';
import TabFilter from '../../../../common/tab-filter';
import { getDefaultIfEmpty } from '../../../../helpers/Common';
import {
  fetchDataAggressive,
  cancelfetchDataAggressive,
  subscribeRealtimeTickAggressive,
  changeFilterLineOne,
  changeFilterLineTwo,
  changeFilterLineThree,
  REDUCER_NAME,
  loadMoreAggressive,
} from '../reducer';
import Const from './Const';
import Table from './Table';
import { I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import MessageHub from '../../../../../core/signalr/SignalrMessageHub';
import { formatTextFloat, formatVolume } from '../../../../helpers/Text';
import TotalVolume from './TotalVolume';

const defaultSortState = { totalMatchedVolume: 'desc' };

class Aggressive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sortState: defaultSortState,
    };
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { filter, currentSearch, watchListId } = this.props;
    if (
      filter !== nextProps.filter ||
      currentSearch !== nextProps.currentSearch ||
      watchListId !== nextProps.watchListId
    ) {
      this.setState({
        page: 1,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState } = this.state;
    const { filter, currentSearch, watchListId } = this.props;
    const isChangeSortState = sortState !== prevState.sortState;
    if (
      filter !== prevProps.filter ||
      currentSearch !== prevProps.currentSearch ||
      watchListId !== prevProps.watchListId ||
      isChangeSortState
    ) {
      this.fetchData();
      if (this.tableRef.current) {
        this.tableRef.current.scrollToTop();
      }
    }
  }

  componentWillUnmount() {
    const { cancelfetchDataAggressive } = this.props;
    cancelfetchDataAggressive();
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  fetchData = () => {
    const { sortState } = this.state;
    const { fetchDataAggressive, filter } = this.props;
    fetchDataAggressive(
      Const.filterAvgVolume[filter.filterLineOne],
      Const.filterOrderType[filter.filterLineTwo].text,
      Const.filterTotalBuSd[filter.filterLineThree],
      sortState,
    );
  };

  onLoadMore = page => {
    const { sortState } = this.state;
    const { loadMoreAggressive, filter } = this.props;
    this.setState({
      page,
    });
    loadMoreAggressive({
      page,
      currentAvgVolume: Const.filterAvgVolume[filter.filterLineOne],
      orderType: Const.filterOrderType[filter.filterLineTwo].text,
      totalVolumeBuSd: Const.filterTotalBuSd[filter.filterLineThree],
      sortState,
    });
  };

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTickAggressive } = this.props;
    subscribeRealtimeTickAggressive(data);
  };

  changeAvgVolume = currentAvgVolume => {
    const { changeFilterLineOne, filter } = this.props;
    if (filter.filterLineOne !== currentAvgVolume) {
      changeFilterLineOne(currentAvgVolume);
    }
  };

  changeOrderType = currentOrderType => {
    const { changeFilterLineTwo, filter } = this.props;
    if (filter.filterLineTwo !== currentOrderType) {
      changeFilterLineTwo(currentOrderType);
    }
  };

  changeTotalBuSd = currentTotalBuSd => {
    const { changeFilterLineThree, filter } = this.props;
    if (filter.filterLineThree !== currentTotalBuSd) {
      changeFilterLineThree(currentTotalBuSd);
    }
  };

  onSort = sortState => {
    this.setState({
      sortState: getDefaultIfEmpty(sortState, defaultSortState),
    });
  };

  render() {
    const { page } = this.state;
    const { filter } = this.props;
    return (
      <div className="d-flex flex-fill flex-column">
        <div>
          <div className="list-filter top-nav">
            <span className="left-label-2 left-label">
              {I18n.t('tasignals.aggressiveContent.line_2')}
            </span>
            <TabFilter
              currentTab={filter.filterLineOne}
              listTab="tasignals.filterAvgVolume"
              changeTab={this.changeAvgVolume}
            />
          </div>
          <div className="list-filter top-nav">
            <span className="left-label-2 left-label">
              {I18n.t('tasignals.aggressiveContent.line_3')}
            </span>
            <TabFilter
              currentTab={filter.filterLineTwo}
              listTab="tasignals.filterOrderType"
              changeTab={this.changeOrderType}
            />
          </div>
          <div className="list-filter top-nav">
            <span className="left-label-2 left-label"> </span>
            <TabFilter
              currentTab={filter.filterLineThree}
              listTab="tasignals.filterVolumeBU_SD"
              changeTab={this.changeTotalBuSd}
            />
          </div>
          <div className="list-text-display">
            <span className="light-text">
              {I18n.t('tasignals.aggressiveContent.line_4.part_1')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.aggressiveContent.line_4.part_2')}
              {formatTextFloat(
                Number(Const.filterAvgVolume[filter.filterLineOne]),
                0,
              )}
            </span>
            <span className="light-text">
              {I18n.t('tasignals.aggressiveContent.line_4.part_3')}
            </span>
            <span className="bold-text">
              {I18n.t('tasignals.aggressiveContent.line_4.part_4')}
              {Const.filterOrderType[filter.filterLineTwo].quote}
              {Const.filterTotalBuSd[filter.filterLineThree]}
              {I18n.t('tasignals.aggressiveContent.line_4.part_5')}
            </span>
          </div>
        </div>
        <div className="mt-10 d-flex flex-fill flex-column">
          <TotalVolume />
          <Table
            page={page}
            onLoadMore={this.onLoadMore}
            scrollRef={this.tableRef}
            onSort={this.onSort}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    currentSearch: state[REDUCER_NAME].currentSearch,
    watchListId: state[REDUCER_NAME].watchListId,
    data: state[REDUCER_NAME].listObjectDeceptiveAggressiveDataByTicker,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchDataAggressive: (currentAvgVolume, totalBuSd, orderType, sortState) =>
      dispatch(
        fetchDataAggressive(currentAvgVolume, totalBuSd, orderType, sortState),
      ),
    cancelfetchDataAggressive: () => dispatch(cancelfetchDataAggressive()),
    subscribeRealtimeTickAggressive: data =>
      dispatch(subscribeRealtimeTickAggressive(data)),
    changeFilterLineOne: value => dispatch(changeFilterLineOne(value)),
    changeFilterLineTwo: value => dispatch(changeFilterLineTwo(value)),
    changeFilterLineThree: value => dispatch(changeFilterLineThree(value)),
    loadMoreAggressive: value => dispatch(loadMoreAggressive(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Aggressive);
